import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { cssHidden } from "@/styles/utils/Utils";
import { colors } from "@/styles/utils/vars";
import { ButtonBase } from "@/ui/Button/StyledButton";
import { cssIcon } from "@/ui/Icon";
import { PopoverContainer, StyledPopoverDisclosure, StyledPopoverInner } from "@/ui/Popover/StyledPopover";
import { Paragraph10 } from "@/ui/Typography/Typography";
export const cssBtnClearItem = "cssBtnClearItem_csoezkz";
export const cssVariantPopover = "cssVariantPopover_cyxkm80";
export const cssVariantRelative = "cssVariantRelative_c1fmfxrw";
export const cssIsActive = "cssIsActive_c1re93qh";
export const StyledPopoverDisclosureFilter = /*#__PURE__*/styled(StyledPopoverDisclosure)({
  name: "StyledPopoverDisclosureFilter",
  class: "StyledPopoverDisclosureFilter_sqqgthd"
});
export const PopoverContainerFilter = /*#__PURE__*/styled(PopoverContainer)({
  name: "PopoverContainerFilter",
  class: "PopoverContainerFilter_p1azudbj"
});
export const StyledFilterCounter = /*#__PURE__*/styled(Paragraph10)({
  name: "StyledFilterCounter",
  class: "StyledFilterCounter_s1f8t0x3"
});

require("./StyledFilterPopover.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledFilterPopover.tsx");